<template>
  <div style="width: 100%">
    <!-- <el-divider class="divider"></el-divider> -->
    <el-form ref="form" :model="form" size="mini" class="panel" label-width="80px">
      <el-form-item label="名称" required>
        <el-input size="mini" v-model="form.name" @change="getFormName"></el-input>
      </el-form-item>
      <el-form-item label="描述">
        <el-input type="textarea" size="mini" min-row="1" v-model="form.desc" @change="getFormName"></el-input>
      </el-form-item>

      <el-form-item label="是否可视">
        <el-switch v-model="form.visiabled" @change="getFormName"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        { label: "单行文本", value: 1 },
        { label: "数字文本", value: 7 },
        { label: "多行文本", value: 2 },
        { label: "单选列表", value: 3 },
        { label: "多选列表", value: 4 },
        { label: "日期组件", value: 6 },
      ],
      listArray: [],
      form: {
        name: "",
        desc: "",
        enabled: true,
      },
    };
  },
  props: {
    tableInfo: {
      type: Object,
    },
  },
  mounted() {
    this.getData();
    // console.log(12312);
  },
  methods: {
    getFormName() {
      this.$emit("edit", this.form);
    },

    async getData() {
      console.log(this.tableInfo);

      const { uiType, label, name, description, enabled } = this.tableInfo;
      this.form = { ...this.form, uiType, name: label || name, desc: description, visiabled: !!Number(enabled) };
    },
  },
};
</script>
<style lang="scss" scoped>
.divider {
  margin: 6px 0;
}
</style>
<style lang="scss">
.panel {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;

  .el-form-item {
    width: 48%;
    margin-bottom: 2px;
  }

  .el-form-item__label {
    font-size: 12px;
    color: #09090b;
  }
}
</style>